export BattlesButton from './BattlesButton/BattlesButton'
export Item from './Item/Item'
export ScheduleButton from './BattlesButton/ScheduleButton'
export Storage from './Storage/Storage'



// WEBPACK FOOTER //
// ./containers/ClanPanel/components/index.js